import { t } from "i18next";
import { ITagCategory } from "../../common/models/ITagCategory";
import OptionsSideSheet from "../options-side-sheet/OptionsSideSheet";
import SideSheetFilterInput from "../side-sheet/side-sheet-filter-input/SideSheetFilterInput";
import SideSheetMultiSelect from "../side-sheet/side-sheet-multiselect/SideSheetMultiSelect";
import SideSheetSwitch from "../side-sheet/side-sheet-switch/SideSheetSwitch";
import { AutocompleteChangeDetails, AutocompleteChangeReason } from "@mui/material";

export type ManualEntryFormSidesheetProps = {

    resetOptions: () => void;
    configurationEnabled?: boolean; // Optional, used for write down configuration
    categories: ITagCategory[];

    selectCategory: (
            reason: AutocompleteChangeReason,
            details?: AutocompleteChangeDetails<ITagCategory> | undefined
        ) => void;

    filterText: string;
    setFilterText: (value: string) => void;


    showAllTagsOption: boolean;
    viewAllTags: boolean;
    setViewAllTags: (viewAllTags: boolean) => void;


    showAllWriteTagsOption: boolean;
    setViewAllWriteTags: (viewAllTags: boolean) => void;
    viewAllWriteTags: boolean;
};


export default function ManualEntryFormSidesheet({
    resetOptions,
    configurationEnabled,
    categories,
    selectCategory,
    filterText,
    setFilterText,
    showAllTagsOption,
    viewAllTags,
    setViewAllTags,

    showAllWriteTagsOption,
    viewAllWriteTags,
    setViewAllWriteTags,


}: ManualEntryFormSidesheetProps) {

    function onCategoryChanged(
        _event: React.SyntheticEvent,
        _value: ITagCategory[],
        reason: AutocompleteChangeReason,
        details?: AutocompleteChangeDetails<ITagCategory> | undefined
    ) {
        selectCategory(reason, details);
    }

    //console.log (`viewAllTags: ${viewAllTags}, viewAllWriteTags: ${viewAllWriteTags}`);
    return (
         <OptionsSideSheet onReset={() => resetOptions()}>
        
            <SideSheetMultiSelect<ITagCategory>
                    id="filter-tags"
                    label={configurationEnabled
                        ? t('objectTagValues.filterTagGroups')
                        : t('category.title')
                    }
                    placeholder={configurationEnabled
                        ? t('objectTagValues.tagGroups')
                        : t('category.placeholder')
                    }
                    options={categories}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    value={categories.filter(o => o.selected)} 
                    getOptionLabel={(option) => option.text}
                    onChange={onCategoryChanged}
                />

                <SideSheetFilterInput
                    label={t("setpointAdmin.filterBy")}
                    value={filterText}
                    onChange={(value: string) => {
                        setFilterText(value);
                    }}
                />

                {
                    showAllTagsOption && 
                    
                    <SideSheetSwitch
                        label='View All Tags in Configuration'
                        checked={viewAllTags}
                        onChange={(checked: boolean) => {
                            setViewAllTags(checked);
                        }}
                    />
                }


                {
                    showAllWriteTagsOption && 
                    <SideSheetSwitch
                        label='View All Writable Tags'
                        checked={viewAllWriteTags}
                        onChange={(checked: boolean) => {
                            setViewAllWriteTags(checked);
                        }}
                    />
                }


        </OptionsSideSheet>
    )
}
